'use strict';
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
var $p;
/** @constructor */
function $c_ju_regex_Pattern$() {
}
export { $c_ju_regex_Pattern$ as $c_ju_regex_Pattern$ };
$p = $c_ju_regex_Pattern$.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_ju_regex_Pattern$;
/** @constructor */
function $h_ju_regex_Pattern$() {
}
export { $h_ju_regex_Pattern$ as $h_ju_regex_Pattern$ };
$h_ju_regex_Pattern$.prototype = $p;
$p.VI = (function(regex, input) {
  return new $j_java$002elang$002e$002dObject.$c_ju_regex_Matcher($j_java$002elang$002e$002dObject.$m_ju_regex_PatternCompiler$().Bj(regex, 0), input).PD();
});
var $d_ju_regex_Pattern$ = new $j_java$002elang$002e$002dObject.$TypeData().i($c_ju_regex_Pattern$, "java.util.regex.Pattern$", ({
  nu: 1,
  a: 1
}));
export { $d_ju_regex_Pattern$ as $d_ju_regex_Pattern$ };
var $n_ju_regex_Pattern$;
function $m_ju_regex_Pattern$() {
  if ((!$n_ju_regex_Pattern$)) {
    $n_ju_regex_Pattern$ = new $c_ju_regex_Pattern$();
  }
  return $n_ju_regex_Pattern$;
}
export { $m_ju_regex_Pattern$ as $m_ju_regex_Pattern$ };
